export const initialFilterState = () => ({
  startDateEffective: null,
  endDateEffective: null,
  startDateCreated: null,
  endDateCreated: null,
});
